export default __webpack_public_path__ + "static/media/093-curved-arrow-3.38534829.png";